import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=2f840158"
import script from "./HeaderBar.vue?vue&type=script&lang=js"
export * from "./HeaderBar.vue?vue&type=script&lang=js"
import style0 from "./HeaderBar.vue?vue&type=style&index=0&id=2f840158&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports